import useMonolithApiQuery from '@/hooks/api/useMonolithApiQuery';
import { BuildCacheToolIds } from '@/models/BuildCacheTool';
import { BuildToolInvocationWithDetails } from '@/models/BuildToolInvocation';
import { SimpleErrorResponse } from '@/models/Error';
import { buildToolChildInvocationsPath } from '@/utils/monolithApiRouteService';

type ChildInvocationGroup = {
  buildTool: BuildCacheToolIds;
  invocations: BuildToolInvocationWithDetails[];
};

const useChildInvocations = (workspaceSlug: string, invocationId: string, enabled = true) => {
  return useMonolithApiQuery<ChildInvocationGroup[], SimpleErrorResponse>(
    ['child_invocations', workspaceSlug, invocationId],
    buildToolChildInvocationsPath(workspaceSlug, invocationId, { format: 'json' }),
    { enabled },
  );
};

export default useChildInvocations;
